import { DataRspSuccess } from "../../velocity/aurora/map";

export type PolygonFeature = GeoJSON.Feature<
    GeoJSON.Polygon,
    GeoJSON.GeoJsonProperties
>;

export enum FunctionType {
    viewport = "viewport",
    radius = "radius",
    polygon = "polygon",
    savedPolygon = "savedPolygon",
    square = "square",
    fillArea = "fillArea",
    draw = "draw",
    data = "data",
}

export type LastFunctionType = Extract<
    FunctionType,
    | FunctionType.polygon
    | FunctionType.square
    | FunctionType.radius
    | FunctionType.fillArea
    | FunctionType.draw
    | FunctionType.data
>;

// ██╗   ██╗███████╗██╗      ██████╗  ██████╗██╗████████╗██╗   ██╗    ███████╗ ██████╗  ██████╗██╗  ██╗███████╗████████╗███████╗
// ██║   ██║██╔════╝██║     ██╔═══██╗██╔════╝██║╚══██╔══╝╚██╗ ██╔╝    ██╔════╝██╔═══██╗██╔════╝██║ ██╔╝██╔════╝╚══██╔══╝██╔════╝
// ██║   ██║█████╗  ██║     ██║   ██║██║     ██║   ██║    ╚████╔╝     ███████╗██║   ██║██║     █████╔╝ █████╗     ██║   ███████╗
// ╚██╗ ██╔╝██╔══╝  ██║     ██║   ██║██║     ██║   ██║     ╚██╔╝      ╚════██║██║   ██║██║     ██╔═██╗ ██╔══╝     ██║   ╚════██║
//  ╚████╔╝ ███████╗███████╗╚██████╔╝╚██████╗██║   ██║      ██║       ███████║╚██████╔╝╚██████╗██║  ██╗███████╗   ██║   ███████║
//   ╚═══╝  ╚══════╝╚══════╝ ╚═════╝  ╚═════╝╚═╝   ╚═╝      ╚═╝       ╚══════╝ ╚═════╝  ╚═════╝╚═╝  ╚═╝╚══════╝   ╚═╝   ╚══════╝

export type DataRspRows = DataRspSuccess["rows"];
export type DataRspRow = DataRspRows[number];

export type CreateSocket = {
    readonly serverUrl: string;
    readonly crate: string;
    readonly path: string;
    readonly userJwt?: string;
};
